export const styleTransfer = [
  'ST-001|Futuristic',
  'ST-002|Pop Art',
  'ST-003|Chalk Drawing',
  'ST-004|Ikea Instruction',
  'ST-005|Pixar Style',
  'ST-006|Lego Style',
  'ST-007|Stop Motion Style',
  'ST-008|Film Noir',
  'ST-009|Studio Ghibli Style',
];
